import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import UserContext from "../../services/Context/UserContext";
import JWT from "../../services/JWT";
import { Lock } from "@mui/icons-material";

export default function Authenticate({ onClick, data }){

    const { user, setUser } = useContext(UserContext)

    const handleCancel = () => {
        setUser(null)
        JWT.removeTokens()
        window.location.reload()
    }

    return (

        <Box>

            <Stack spacing={3} sx={{maxWidth: 500, margin: 'auto'}}>

                <Typography>
                        Vous êtes authentifié en tant que <b>{user.name} ({user.email})</b>.
                </Typography>

                {user.email.toLowerCase() === data.email.toLowerCase() ? <>

                    <Typography>
                        En cliquant sur <b>Continuer</b>, vous confirmez votre identité.
                    </Typography>

                    <Button variant='contained' onClick={onClick}>
                        Continuer
                    </Button>

                </> :

                    <Alert severity="error" icon={<Lock />}>
                        Vous n'êtes pas autorisé à signer ce document.
                    </Alert>
                }

                <Button variant='outlined' onClick={handleCancel}>
                    Changer de compte
                </Button>

            </Stack>

        </Box>
    )
}